<template>
    <div>
        <Head />
        <div class="hotspot clear">
            <Nav ms="/Information" />
            <div class="H-right">
                <main>
                    <div class="title">
                        <div>
                            <i></i>
                            <h3>企业信息</h3>
                        </div>
                        <div class="btn" @click="dialogFormVisible = true">修改密码</div>
                        <el-dialog
                            width="30%"
                            title="修改密码"
                            style="text-align: center"
                            :visible.sync="dialogFormVisible"
                        >
                            <el-form :model="form">
                                <el-form-item label="原密码" :label-width="formLabelWidth">
                                    <el-input
                                        v-model="form.password"
                                        type="password"
                                        placeholder="请输入原密码"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="新密码" :label-width="formLabelWidth">
                                    <el-input
                                        v-model="form.password1"
                                        type="password"
                                        placeholder="请输入新密码密码"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="确认密码" :label-width="formLabelWidth">
                                    <el-input
                                        v-model="form.password2"
                                        type="password"
                                        placeholder="请输入新密码密码"
                                    ></el-input>
                                </el-form-item>
                            </el-form>
                            <div slot="footer" class="dialog-footer">
                                <el-button @click="dialogFormVisible = false">取 消</el-button>
                                <el-button type="primary" @click="changpswd">确 定</el-button>
                            </div>
                        </el-dialog>
                    </div>
                    <div class="container">
                        <!-- <el-table :show-header="true" :data="tableData" style="width: 100%">
            <el-table-column prop="name" width="300" ></el-table-column>
            <el-table-column prop="phone" style="width:100%"></el-table-column>
            </el-table>-->
                        <div>
                            <b>公司名称:</b>
                            <p>{{ userinfo.Name }}</p>
                        </div>
                        <div>
                            <b>企业性质:</b>
                            <p>{{ userinfo.PropertyName }}</p>
                        </div>
                        <div>
                            <b>联系人：</b>
                            <p>{{ userinfo.Manager }}</p>
                        </div>
                        <div>
                            <b>手机号码：</b>
                            <p>{{ userinfo.Phone }}</p>
                        </div>
                        <div>
                            <b>
                                地
                                <span></span> 址：
                            </b>
                            <p>{{ userinfo.City }}</p>
                        </div>

                        <div>
                            <b>所在部门：</b>
                            <p>{{ userinfo.Department }}</p>
                        </div>
                        <div>
                            <b>
                                职
                                <span></span>务:
                            </b>
                            <p>{{ userinfo.Position }}</p>
                        </div>
                        <div>
                            <b>企业信用代码：</b>
                            <p>{{ userinfo.Code }}</p>
                        </div>
                        <div>
                            <b>电子邮箱：</b>
                            <p>{{ userinfo.Email }}</p>
                        </div>
                        <div class="license">
                            <b>营业执照:</b>
                            <div>
                                <!-- <el-img @click="imgshow = true" :src="userinfo.Image" alt ></el-img> -->
                                <el-image
                                    v-if="userinfo.Image"
                                    style="
                    margin-top: 0.2rem;
                    margin-bottom: 0.2rem;
                    max-width: 50%;
                    max-height: 100%;
                  "
                                    :preview-src-list="[userinfo.Image]"
                                    :src="userinfo.Image"
                                ></el-image>
                            </div>
                        </div>
                        <div class="intro">
                            <b>企业简介：</b>
                            <p
                                v-if="show == 1"
                                v-html="userinfo.introduction ? userinfo.introduction : '暂无企业简介'"
                            ></p>
                            <!-- <p v-if="show == 1">
                {{
                  userinfo.introduction ? userinfo.introduction : "暂无企业简介"
                }}
              </p> -->
                            <wangEditor v-if="show == 2" v-model="userinfo.introduction" />
                            <!-- <el-input
                v-if="show == 2"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 10 }"
                placeholder="请输入企业简介"
                v-model="userinfo.introduction"
              >
              </el-input> -->
                        </div>
                        <el-button type="primary" @click="change" class="change">{{ btn }}</el-button>
                    </div>
                </main>
            </div>
        </div>
        <el-dialog title="营业执照" style="text-align: center" width="40%" :visible.sync="imgshow">
            <img style="max-width: 100%; max-height: 100%" :src="userinfo.Image" alt />
        </el-dialog>
        <Foot />
    </div>
</template>

<script>
import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
import Nav from "../../components/BackNav";
import wangEditor from "../../components/wangEnduit/wangEnduitReport";
export default {
    data() {
        return {
            // introduction: "",
            show: 1,
            dialogFormVisible: false,
            imgshow: false,
            form: {
                password: "",
                password1: "",
                password2: "",
            },
            formLabelWidth: "100px",
            userinfo: "",
            xingzhi: "",
        };
    },
    computed: {
        btn() {
            return this.show == 1 ? "修改" : "保存";
        },
    },
    created() {
        // let that = this;
        if (sessionStorage.getItem("userinfo")) {
            this.getData();
        }
        // console.log(sessionStorage.getItem("userinfo"))

        // switch(this.userinfo.Property){
        //   case "1":
        //     this.xingzhi="集团公司"
        //     break;
        //     case "2":
        //     this.xingzhi="井工煤矿"
        //     break;
        //     case "3":
        //     this.xingzhi="露天煤矿"
        //     break;
        //     case "4":
        //     this.xingzhi="煤炭洗选企业"
        //     break;
        //     case "5":
        //     this.xingzhi="化工企业"
        //     break;
        //     case "6":
        //     this.xingzhi="煤炭施工企业"
        //     break;
        //     case "7":
        //     this.xingzhi="煤炭机械制造企业"
        //     break;
        //     case "8":
        //     this.xingzhi="煤炭运销企业"
        //     break;
        //     case "9":
        //     this.xingzhi="电力企业"
        //     break;
        //   case "10":
        //     this.xingzhi="其他企业"
        //     break;
        // }
    },
    methods: {
        getData() {
            let that = this;
            var id = JSON.parse(sessionStorage.getItem("userinfo")).ID;
            console.log(id);
            this.$axios
                .post(
                    "company/info",
                    that.$qs.stringify({
                        ID: id,
                        token: sessionStorage.getItem("token"),
                    })
                )
                .then((res) => {
                    console.log(res);
                    if (res.data.code == 10000) {
                        this.userinfo = res.data.data;
                    } else {
                        that.$message(res.data.msg);
                    }
                });
        },
        change() {
            if (this.show == 1) {
                this.show = 2;
            } else {
                console.log(this.userinfo.introduction, 22);
                this.$axios
                    .post(
                        "company/update_companyinfo",
                        this.$qs.stringify({
                            ID: JSON.parse(sessionStorage.getItem("userinfo")).ID,
                            introduction: this.userinfo.introduction,
                            token: sessionStorage.getItem("token"),
                        })
                    )
                    .then((res) => {
                        console.log(res);
                        if (res.data.code == 10000) {
                            this.$message.success("修改成功");
                            // this.getData();
                            window.location.reload();
                        } else {
                            this.$message(res.data.msg);
                        }
                    });
            }
        },
        changpswd() {
            let that = this;
            for (var key in this.form) {
                if (!this.form[key]) {
                    this.$message({
                        message: "信息填写不完整,请重新输入",
                        type: "warning",
                    });
                    return;
                }
            }
            const regex = /^.*(?=.{8,16})(?=.*\d)(?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*[!@#$%_^&*.?\\(\\)])(?!.*?[^\S*]).*$/;

            if (!regex.test(this.form.password1)) {
                this.$message({
                    message: "密码要求：长度为8-16个字符，必须包含大小写字母、数字、特殊符号（!@#$%_^&*.?不包括空格）",
                    type: "warning",
                });
                return;
            }
            if (this.form.password1 != this.form.password2) {
                this.$message({
                    message: "两次输入密码不一致",
                    type: "warning",
                });
                return;
            }
            that.$axios
                .post("welcome/setpwd?token=" + sessionStorage.getItem("token"), that.$qs.stringify(that.form))
                .then((res) => {
                    if (res.data.code == 10000) {
                        that.$message({ message: "修改成功", type: "success" });
                        that.dialogFormVisible = false;
                        that.$axios.post("login/logout?token=" + sessionStorage.getItem("token")).then((res) => {
                            if (res.data.code == 10000) {
                                sessionStorage.clear();
                                that.$message(res.data.msg);
                                that.$router.replace("/");
                                location.reload();

                                // that.isLogin=true
                            } else {
                                that.$message(res.data.msg);
                            }
                        });
                        //   location.reload()
                        //   for(var key in that.form){
                        //       console.log(that.form[key])
                        //   }
                    } else {
                        that.$message(res.data.msg);
                    }
                });
        },
    },
    components: {
        Head,
        Foot,
        Nav,
        wangEditor,
    },
};
</script>

<style lang="less">
.hotspot {
    .editor {
        .text {
            min-height: 200px;
        }
    }
}
</style>
<style lang="less" scoped>
.clear:after {
    /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
}
.hotspot {
    width: 100%;
    min-width: 1000px;
    font-size: 0.16rem;
    padding: 0.28rem 2.54rem;
    box-sizing: border-box;
    .H-right {
        position: relative;
        width: 11.5rem;
        padding-left: 0.2rem;
        height: 100%;
        float: right;
        min-height: 8rem;
        border-left: 1px #eeeeee solid;
        main {
            width: 100%;
            margin-left: 0.3rem;
            padding: 0 2rem 0 0.5rem;

            .title {
                display: flex;
                justify-content: space-between;

                .btn {
                    font-size: 0.18rem;
                    cursor: pointer;
                    width: 0.94rem;
                    height: 0.34rem;
                    background: #2d65d2;
                    border-radius: 0.04rem;
                    color: white;
                    display: flex;
                    justify-content: center;
                }
                > div {
                    display: flex;
                    align-items: center;
                    i {
                        display: inline-block;
                        width: 0.3rem;
                        height: 0.3rem;
                        background-image: url("../../assets/Declare/geren1.png");
                        background-repeat: no-repeat;
                        background-size: 100%;
                        margin-right: 0.1rem;
                    }
                }
            }
            .container {
                margin-top: 0.5rem;
                > div {
                    display: flex;
                    justify-content: space-between;
                    border-bottom: 0.01rem solid #d9d9d9;
                    line-height: 0.8rem;
                    b {
                        color: #505050;
                        font-size: 0.18rem;
                    }
                    span {
                        display: inline-block;
                        width: 0.25rem;
                    }
                    p {
                        width: 70%;
                        color: #181818;
                        font-size: 0.2rem;
                    }
                }
                div.license {
                    // width: 60%;
                    height: 100%;
                    div {
                        width: 70%;
                        img {
                            cursor: pointer;
                        }
                    }
                }
                div.intro {
                    border-bottom: 0;
                    p {
                        line-height: 0.4rem;
                        margin-top: 0.2rem;
                    }
                    .editor {
                        width: 70%;
                        margin-top: 0.3rem;
                    }
                    // .el-textarea {
                    //   width: 70%;
                    //   margin-top: 0.2rem;
                    // }
                }
                .change {
                    margin: 0.4rem 0 0 2.68rem;
                }
            }
        }
    }
}
</style>
